import { Component } from '@angular/core';

@Component({
  selector: 'app-compat-contact-list',
  template: ''
})
export class CompatContactListComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/compat/compat-contact-list.component.ts